module.exports = __webpack_public_path__ + "static/img/rank_122.0e65d0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_122.png
// module id = UC/9
// module chunks = 0